<!-- @format -->
<script lang="ts">
  export let fragment: Fragment;
  const { definition } = fragment;
  const { fragmentConfig } = definition;
  const { htmlCode } = fragmentConfig;
</script>

{#if htmlCode}
  <div class="iframe">
    {@html htmlCode}
  </div>
{/if}

<style>
  .iframe :global(iframe) {
    width: 100%;
    aspect-ratio: 448/215;
    filter: gray; /* IE6-9 */
    -webkit-filter: grayscale(99%); /* Chrome 19+ & Safari 6+ */
  }
</style>
